import { _ as Ce, b as Ae } from "./index-513216cd.js";
import * as R from "react";
import je, { version as Me, isValidElement as $e } from "react";
import { R as D } from "./index-99ae6cc1.js";
function Ie(e) {
  if (Array.isArray(e))
    return e;
}
function Le(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n, u, f, s, d = [], l = !0, y = !1;
    try {
      if (f = (t = t.call(e)).next, r === 0) {
        if (Object(t) !== t)
          return;
        l = !1;
      } else
        for (; !(l = (n = f.call(t)).done) && (d.push(n.value), d.length !== r); l = !0)
          ;
    } catch (v) {
      y = !0, u = v;
    } finally {
      try {
        if (!l && t.return != null && (s = t.return(), Object(s) !== s))
          return;
      } finally {
        if (y)
          throw u;
      }
    }
    return d;
  }
}
function Y(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Ne(e, r) {
  if (e) {
    if (typeof e == "string")
      return Y(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Y(e, r) : void 0;
  }
}
function Fe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function or(e, r) {
  return Ie(e) || Le(e, r) || Ne(e, r) || Fe();
}
function S(e) {
  "@babel/helpers - typeof";
  return S = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, S(e);
}
function xe(e, r) {
  if (S(e) != "object" || !e)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (S(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function G(e) {
  var r = xe(e, "string");
  return S(r) == "symbol" ? r : r + "";
}
function De(e, r, t) {
  return (r = G(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function V(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function ir(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? V(Object(t), !0).forEach(function(n) {
      De(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : V(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Ye() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Ve(e, r) {
  if (e == null)
    return {};
  var t = {};
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      if (r.includes(n))
        continue;
      t[n] = e[n];
    }
  return t;
}
function ur(e, r) {
  if (e == null)
    return {};
  var t, n, u = Ve(e, r);
  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(e);
    for (n = 0; n < f.length; n++)
      t = f[n], r.includes(t) || {}.propertyIsEnumerable.call(e, t) && (u[t] = e[t]);
  }
  return u;
}
function ze(e, r, t) {
  var n = R.useRef({});
  return (!("value" in n.current) || t(n.current.condition, r)) && (n.current.value = e(), n.current.condition = r), n.current.value;
}
var A = {}, $ = [], We = function(r) {
  $.push(r);
};
function Ue(e, r) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var t = $.reduce(function(n, u) {
      return u(n ?? "", "warning");
    }, r);
    t && console.error("Warning: ".concat(t));
  }
}
function qe(e, r) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var t = $.reduce(function(n, u) {
      return u(n ?? "", "note");
    }, r);
    t && console.warn("Note: ".concat(t));
  }
}
function Be() {
  A = {};
}
function K(e, r, t) {
  !r && !A[t] && (e(!1, t), A[t] = !0);
}
function I(e, r) {
  K(Ue, e, r);
}
function He(e, r) {
  K(qe, e, r);
}
I.preMessage = We;
I.resetWarned = Be;
I.noteOnce = He;
function ar(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function z(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, G(n.key), n);
  }
}
function cr(e, r, t) {
  return r && z(e.prototype, r), t && z(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function fr(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), r && Ce(e, r);
}
function h(e) {
  return h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, h(e);
}
function X() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (X = function() {
    return !!e;
  })();
}
function Ge(e, r) {
  if (r && (S(r) == "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ae(e);
}
function sr(e) {
  var r = X();
  return function() {
    var t, n = h(e);
    if (r) {
      var u = h(this).constructor;
      t = Reflect.construct(n, arguments, u);
    } else
      t = n.apply(this, arguments);
    return Ge(this, t);
  };
}
var W = process.env.NODE_ENV !== "test" && Ye() ? R.useLayoutEffect : R.useEffect, Ke = function(r, t) {
  var n = R.useRef(!0);
  W(function() {
    return r(n.current);
  }, t), W(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, lr = function(r, t) {
  Ke(function(n) {
    if (!n)
      return r();
  }, t);
};
function pr(e) {
  var r = R.useRef();
  r.current = e;
  var t = R.useCallback(function() {
    for (var n, u = arguments.length, f = new Array(u), s = 0; s < u; s++)
      f[s] = arguments[s];
    return (n = r.current) === null || n === void 0 ? void 0 : n.call.apply(n, [r].concat(f));
  }, []);
  return t;
}
var j = { exports: {} }, a = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U;
function Xe() {
  if (U)
    return a;
  U = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), s = Symbol.for("react.context"), d = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), w;
  w = Symbol.for("react.module.reference");
  function p(o) {
    if (typeof o == "object" && o !== null) {
      var _ = o.$$typeof;
      switch (_) {
        case e:
          switch (o = o.type, o) {
            case t:
            case u:
            case n:
            case y:
            case v:
              return o;
            default:
              switch (o = o && o.$$typeof, o) {
                case d:
                case s:
                case l:
                case E:
                case b:
                case f:
                  return o;
                default:
                  return _;
              }
          }
        case r:
          return _;
      }
    }
  }
  return a.ContextConsumer = s, a.ContextProvider = f, a.Element = e, a.ForwardRef = l, a.Fragment = t, a.Lazy = E, a.Memo = b, a.Portal = r, a.Profiler = u, a.StrictMode = n, a.Suspense = y, a.SuspenseList = v, a.isAsyncMode = function() {
    return !1;
  }, a.isConcurrentMode = function() {
    return !1;
  }, a.isContextConsumer = function(o) {
    return p(o) === s;
  }, a.isContextProvider = function(o) {
    return p(o) === f;
  }, a.isElement = function(o) {
    return typeof o == "object" && o !== null && o.$$typeof === e;
  }, a.isForwardRef = function(o) {
    return p(o) === l;
  }, a.isFragment = function(o) {
    return p(o) === t;
  }, a.isLazy = function(o) {
    return p(o) === E;
  }, a.isMemo = function(o) {
    return p(o) === b;
  }, a.isPortal = function(o) {
    return p(o) === r;
  }, a.isProfiler = function(o) {
    return p(o) === u;
  }, a.isStrictMode = function(o) {
    return p(o) === n;
  }, a.isSuspense = function(o) {
    return p(o) === y;
  }, a.isSuspenseList = function(o) {
    return p(o) === v;
  }, a.isValidElementType = function(o) {
    return typeof o == "string" || typeof o == "function" || o === t || o === u || o === n || o === y || o === v || o === T || typeof o == "object" && o !== null && (o.$$typeof === E || o.$$typeof === b || o.$$typeof === f || o.$$typeof === s || o.$$typeof === l || o.$$typeof === w || o.getModuleId !== void 0);
  }, a.typeOf = p, a;
}
var c = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q;
function Ze() {
  return q || (q = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), s = Symbol.for("react.context"), d = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), w = !1, p = !1, o = !1, _ = !1, ee = !1, L;
    L = Symbol.for("react.module.reference");
    function re(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === t || i === u || ee || i === n || i === y || i === v || _ || i === T || w || p || o || typeof i == "object" && i !== null && (i.$$typeof === E || i.$$typeof === b || i.$$typeof === f || i.$$typeof === s || i.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === L || i.getModuleId !== void 0));
    }
    function m(i) {
      if (typeof i == "object" && i !== null) {
        var C = i.$$typeof;
        switch (C) {
          case e:
            var g = i.type;
            switch (g) {
              case t:
              case u:
              case n:
              case y:
              case v:
                return g;
              default:
                var x = g && g.$$typeof;
                switch (x) {
                  case d:
                  case s:
                  case l:
                  case E:
                  case b:
                  case f:
                    return x;
                  default:
                    return C;
                }
            }
          case r:
            return C;
        }
      }
    }
    var te = s, ne = f, oe = e, ie = l, ue = t, ae = E, ce = b, fe = r, se = u, le = n, pe = y, ye = v, N = !1, F = !1;
    function me(i) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ve(i) {
      return F || (F = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function de(i) {
      return m(i) === s;
    }
    function be(i) {
      return m(i) === f;
    }
    function Ee(i) {
      return typeof i == "object" && i !== null && i.$$typeof === e;
    }
    function Se(i) {
      return m(i) === l;
    }
    function Re(i) {
      return m(i) === t;
    }
    function _e(i) {
      return m(i) === E;
    }
    function we(i) {
      return m(i) === b;
    }
    function ge(i) {
      return m(i) === r;
    }
    function Pe(i) {
      return m(i) === u;
    }
    function he(i) {
      return m(i) === n;
    }
    function Oe(i) {
      return m(i) === y;
    }
    function Te(i) {
      return m(i) === v;
    }
    c.ContextConsumer = te, c.ContextProvider = ne, c.Element = oe, c.ForwardRef = ie, c.Fragment = ue, c.Lazy = ae, c.Memo = ce, c.Portal = fe, c.Profiler = se, c.StrictMode = le, c.Suspense = pe, c.SuspenseList = ye, c.isAsyncMode = me, c.isConcurrentMode = ve, c.isContextConsumer = de, c.isContextProvider = be, c.isElement = Ee, c.isForwardRef = Se, c.isFragment = Re, c.isLazy = _e, c.isMemo = we, c.isPortal = ge, c.isProfiler = Pe, c.isStrictMode = he, c.isSuspense = Oe, c.isSuspenseList = Te, c.isValidElementType = re, c.typeOf = m;
  }()), c;
}
process.env.NODE_ENV === "production" ? j.exports = Xe() : j.exports = Ze();
var P = j.exports, Je = function(r, t) {
  typeof r == "function" ? r(t) : S(r) === "object" && r && "current" in r && (r.current = t);
}, Qe = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  var u = t.filter(Boolean);
  return u.length <= 1 ? u[0] : function(f) {
    t.forEach(function(s) {
      Je(s, f);
    });
  };
}, yr = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return ze(function() {
    return Qe.apply(void 0, t);
  }, t, function(u, f) {
    return u.length !== f.length || u.every(function(s, d) {
      return s !== f[d];
    });
  });
}, ke = function(r) {
  var t, n, u = P.isMemo(r) ? r.type.type : r.type;
  return !(typeof u == "function" && !((t = u.prototype) !== null && t !== void 0 && t.render) && u.$$typeof !== P.ForwardRef || typeof r == "function" && !((n = r.prototype) !== null && n !== void 0 && n.render) && r.$$typeof !== P.ForwardRef);
};
function M(e) {
  return /* @__PURE__ */ $e(e) && !P.isFragment(e);
}
var mr = function(r) {
  return M(r) && ke(r);
};
Number(Me.split(".")[0]) >= 19;
function B(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function er(e) {
  return e && S(e) === "object" && B(e.nativeElement) ? e.nativeElement : B(e) ? e : null;
}
function vr(e) {
  var r = er(e);
  if (r)
    return r;
  if (e instanceof je.Component) {
    var t;
    return (t = D.findDOMNode) === null || t === void 0 ? void 0 : t.call(D, e);
  }
  return null;
}
var Z = function(r) {
  return +setTimeout(r, 16);
}, J = function(r) {
  return clearTimeout(r);
};
typeof window < "u" && "requestAnimationFrame" in window && (Z = function(r) {
  return window.requestAnimationFrame(r);
}, J = function(r) {
  return window.cancelAnimationFrame(r);
});
var H = 0, O = /* @__PURE__ */ new Map();
function Q(e) {
  O.delete(e);
}
var k = function(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  H += 1;
  var n = H;
  function u(f) {
    if (f === 0)
      Q(n), r();
    else {
      var s = Z(function() {
        u(f - 1);
      });
      O.set(n, s);
    }
  }
  return u(t), n;
};
k.cancel = function(e) {
  var r = O.get(e);
  return Q(e), J(r);
};
process.env.NODE_ENV !== "production" && (k.ids = function() {
  return O;
});
export {
  fr as _,
  sr as a,
  cr as b,
  ar as c,
  ir as d,
  S as e,
  vr as f,
  De as g,
  or as h,
  k as i,
  Ke as j,
  I as k,
  ur as l,
  pr as m,
  Y as n,
  Ne as o,
  Ye as p,
  ze as q,
  P as r,
  ke as s,
  lr as t,
  yr as u,
  Ie as v,
  Ue as w,
  Fe as x,
  mr as y,
  Je as z
};
//# sourceMappingURL=raf-5cec7935.js.map
